import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleInput from "../../../../modules/SimpleInput";
import Api from "../../../../Services/Api";
import { fetchDataAsync } from "../../../../Services/Utils";
import { HttpStatus, INITIAL_PAGINATION } from "../../../common/Constants";
import { getDetailTableConfig } from "./config";
import InventoryPartDetailHistory from "./inventoryPartDetailHistory";
import { defaultTableChange } from "../../../../modules/custom/customTable";

class InventoryPartDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: INITIAL_PAGINATION,
      dataTable: [],
      keyword: null,
      searchValue: {
        keyword: null,
      },
      detailHistory: {
        visible: false,
        barcode: null,
      },
      dataDetail:{}
    };
  }

  componentDidMount() {
    this.fetchDataDetail();
  }

  fetchDataDetail = async () => {
    const { onTriggerLoading, selectedData, setError } = this.props;
    if (!selectedData) return;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailInventoryPart,
      menuName: "Inventory Part",
      setError: setError,
      args: {
        partCode: selectedData?.partCode,
        locator: selectedData?.locator,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data?.map((item) => ({ qrCode: item })),
      }));
    }
  };

  getTableConfig = () => {
    return getDetailTableConfig({
      onClickHistory: this.handleDetailHistoryVisibility,
    });
  };

  handleInputKeyword = (value) => {
    this.setState({ keyword: value });
  };

  handleDetailHistoryVisibility = (barcode) => {
    this.setState((prev) => ({
      ...prev,
      detailHistory: {
        visible: !prev.detailHistory.visible,
        barcode: barcode,
      },
    }));
  };

  getTableData = () => {
    const { searchValue, dataTable } = this.state;
    if (searchValue.keyword) {
      return dataTable.filter((item) => item.qrCode === searchValue.keyword);
    }
    return dataTable;
  };

  fetchPartByQrCode = async (keyword) => {
    const { onTriggerLoading, setError, kodeCabang } = this.props
    onTriggerLoading()
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").findBarcodePartInventory,
      menuName: "Inventory Part",
      setError,
      args:{
        kodeCabang: kodeCabang?.value,
        partCode: keyword
      }
    })
    onTriggerLoading()
    if(res.ok && res.data.status === HttpStatus.SUCCESS){
      const {qrCodes, ...rest} = res.data.data
      this.setState(prev=>({
        ...prev,
        dataTable: qrCodes?.map((item) => ({ qrCode: item })),
        dataDetail: rest
      }))
    }
  }

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };
  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    const { onClickClose, visible, selectedData, source } = this.props;
    const { pagination, dataDetail, keyword, detailHistory } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="Detail Inventory Part"
          visible={visible}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <div className="grid grid-2x grid-mobile-none gap-20px margin-bottom-20px">
                <div id="grid-1">
                  <SimpleInput
                    id="input_text_kode_part"
                    name="partCode"
                    label="Kode Part"
                    readOnly
                    value={selectedData?.partCode || dataDetail?.partCode}
                  />
                  <SimpleInput
                    id="input_text_nama_part"
                    name="partName"
                    label="Nama Part"
                    readOnly
                    value={selectedData?.partName || dataDetail?.partName}
                  />
                </div>
                <div id="grid-2">
                  <SimpleInput
                    id="input_text_kategori_part"
                    name="category"
                    label="Kategori Part"
                    readOnly
                    value={selectedData?.category || dataDetail?.category}
                  />
                  <SimpleInput
                    id="input_text_locator"
                    name="locator"
                    label="Locator"
                    readOnly
                    value={selectedData?.locatorName || dataDetail?.locatorName}
                  />
                </div>
              </div>
              <FlexView
                vAlignContent="center"
                hAlignContent="right"
                style={{ gap: "15px" }}
              >
                <h4 className="txt-site txt-14 txt-main txt-bold margin-bottom-20px">
                  QR Code
                </h4>
                <SimpleInput
                  id="input_text_search"
                  name="searchValue"
                  className="txt txt-sekunder-color"
                  type="text"
                  value={keyword}
                  onChange={({ target }) =>
                    this.handleInputKeyword(target.value)
                  }
                />
                <SimpleButton
                  text="CARI"
                  id="btn_search_qr"
                  className="margin-bottom-20px"
                  onClick={() => {
                    if (source === "search-qr-main-page") {
                      this.fetchPartByQrCode(keyword);
                      return;
                    } else {
                      this.setState({
                        searchValue: {
                          keyword: keyword,
                        },
                      });
                    }
                  }}
                />
              </FlexView>
              <SimpleDataTable
                key={`${pagination.totalData}-${pagination.page}`}
                data={this.getTableData()}
                columns={this.getTableConfig()}
                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                rowsPerPage={pagination.limit}
                toCount={pagination.totalData}
                page={pagination.page - 1}
              />
              {detailHistory.visible && (
                <InventoryPartDetailHistory
                  {...this.props}
                  barcode={detailHistory.barcode}
                  active={detailHistory.visible}
                  onClickClose={this.handleDetailHistoryVisibility}
                />
              )}
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default InventoryPartDetail;
